export default __webpack_public_path__ + "media/samples/Current_Live_Stream-c8ce9c7b.jpeg";